import { useState } from "react";
import CopiedIcon from "../icons/CopiedIcon";
import CopyIcon from "../icons/CopyIcon";
import TextWrapper from "../textWrapper/TextWrapper";
import styles from "./copyTextBtn.module.css";

const CopyTextBtn = ({ getText, onCopied }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const text = getText()?.trim() ?? "";
    if (!text) return;

    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }

    setCopied(true);
    onCopied?.();
    setTimeout(() => setCopied(false), 1200);
  };

  return (
    <div className={styles.container} onClick={handleCopy}>
      {copied ? (
        <CopiedIcon className={styles.copyIcon} />
      ) : (
        <CopyIcon className={styles.copyIcon} />
      )}
      <TextWrapper className={styles.copyText} textStyle={"textXXSmall"}>
        {copied ? "تم النسخ" : "نسخ"}
      </TextWrapper>
    </div>
  );
};

export default CopyTextBtn;
